var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegenerative(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "51px",
    viewBox: "0 0 49 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Regenerative") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "Regenerative"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 1.338422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0109541,48.4212532 L34.0109541,38.9870885 C34.1839036,38.9928064 34.3337158,38.9928064 34.4603906,38.9870885 C41.0978599,38.687484 46.3871317,33.2114298 46.3871317,26.5 C46.3871317,19.5964406 40.7906911,14 33.8871317,14 C26.9835723,14 21.3871317,19.5964406 21.3871317,26.5 C21.3871317,31.9407034 24.8631005,36.5695508 29.7154477,38.2869516 C29.7269391,38.3042149 19.8217899,38.3042149 -2.84217094e-14,38.2869516 L7.43565002,27.9426102",
    id: "Oval",
    stroke: "#979797",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(23.193566, 31.210627) scale(-1, 1) translate(-23.193566, -31.210627) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "#979797",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "27.3877874 42.7864562 27.3877874 48.4212532 32.0000608 48.4212532 32.0000608 39.3465782"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    stroke: "#979797",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "35.856587 14.8501628 42.6739396 23.9295669 24.7203519 23.9295669"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.3761775,
    y1: 23.9295669,
    x2: 12.3761775,
    y2: 39.3465782,
    id: "Path-4",
    stroke: "#979797",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.48061566,
    y1: 29.0596498,
    x2: 12.3761775,
    y2: 31.9552116,
    id: "Path-5",
    stroke: "#979797",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.5039522,
    y1: 32.3652778,
    x2: 12.3761775,
    y2: 35.4930524,
    id: "Path-6",
    stroke: "#979797",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.1935658,
    y1: 14.8501628,
    x2: 25.8565365,
    y2: 11.2285376,
    id: "Path-7",
    stroke: "#979797",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    stroke: "#979797",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    points: "29.5 0 38 11 21 11"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegenerative);
export default __webpack_public_path__ + "static/media/regenerative.521c38ab01cad751a50f4072d20b8679.svg";
export { ForwardRef as ReactComponent };